module.exports = "<switchboard-ivr-script-list *ngIf=\"!is_detail\" (onOpenView)=\"openDetail($event.item)\"></switchboard-ivr-script-list>\n<switchboard-ivr-script-detail *ngIf=\"is_detail\" (onBack)=\" is_detail = false;\" [cp]=\"item\"></switchboard-ivr-script-detail>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/script/script.component.html
// module id = ./src/app/pages/admin/icontact/setting/switchboard/ivr/script/script.component.html
// module chunks = main